import React, { useEffect, useState } from "react";
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { cilLockLocked, cilUser } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { fetchUserEdit } from "../../../redux/actions/userAction";
import { useAppDispatch } from "../../../redux/hook";
import { getUserID } from "../../../utils/utils";
import { checkError } from "./../../../utils/utils";

const AppHeaderDropdown = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [userEditData, setUserEditData] = useState([]);

  useEffect(() => {
    const loadUserEdit = async () => {
      const userEditDataTemp = {
        id: getUserID(),
      };

      const userEdit = await dispatch(fetchUserEdit(userEditDataTemp));

      if (typeof userEdit.payload === "string") {
        setLoading(false);
      } else {
        setLoading(false);
        setUserEditData(userEdit.payload);
      }
    };
    loadUserEdit();
  }, [dispatch, userEditData.length]);

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle
        placement="bottom-end"
        className="py-0 pe-0"
        caret={false}
      >
        <CAvatar
          src={
            process.env.REACT_APP_API_URL +
            "/wwwroot/images/" +
            userEditData?.image_file
          }
          size="md"
        />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-body-secondary fw-semibold my-2">
          Settings
        </CDropdownHeader>
        <CDropdownItem href="#">
          <CIcon icon={cilUser} className="me-2" />
          Profile
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem
          href="#"
          onClick={() => navigate(checkError("Error:undefined"))}
        >
          <CIcon icon={cilLockLocked} className="me-2" />
          {t("common.exit")}
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default AppHeaderDropdown;
